export async function createPendingPaymentSubscription({
  planId,
  createPaymentIntent,
  trackFunnelEvent,
  userId,
  currency = 'usd',
  surface = 'subscription_checkout',
}) {
  let paymentIntent;
  try {
    paymentIntent = await createPaymentIntent({ currency });
  } catch (error) {
    if (typeof trackFunnelEvent === 'function') {
      await trackFunnelEvent('payment.intent.failed', {
        userId,
        metadata: {
          plan_id: planId,
          currency,
          surface,
          reason: 'payment_intent_error',
        },
      });
    }
    throw error;
  }

  const subscription = {
    id: paymentIntent.payment_intent_id,
    planId,
    status: paymentIntent.status,
    paymentIntentId: paymentIntent.payment_intent_id,
    clientSecret: paymentIntent.client_secret,
    amount: paymentIntent.amount,
    currency: paymentIntent.currency,
  };

  if (typeof trackFunnelEvent === 'function') {
    await trackFunnelEvent('payment.intent.created', {
      userId,
      metadata: {
        plan_id: planId,
        payment_intent_id: paymentIntent.payment_intent_id,
        amount: paymentIntent.amount,
        currency: paymentIntent.currency,
        status: paymentIntent.status,
        surface,
      },
    });
  }

  return subscription;
}
